import { MutationTree } from "vuex";
import {
  IDeclinedTransactionsDto,
  IDeclinedTransactionsState
} from "./types";

export namespace DECLINED_TRANSACTIONS_MUTATIONS {
  export const SET_DECLINED_TRANSACTIONS_LIST = "setDeclinedTransactionsList";
  export const SET_DECLINED_TRANSACTIONS_LIST_TOTAL = "setDeclinedTransactionsListTotal";
  export const SET_DECLINED_TRANSACTIONS_PAGINATION = "setDeclinedTransactionsPagination";
  export const SET_DECLINED_TRANASCTIONS_FILTERS = "setDeclinedTransactionsFilterss";
  export const SET_DECLINE_CODES = "setDeclineCodes";
}

export const mutations: MutationTree<IDeclinedTransactionsState> = {
  [DECLINED_TRANSACTIONS_MUTATIONS.SET_DECLINED_TRANSACTIONS_LIST](
    state: IDeclinedTransactionsState,
    declinedTransactionsList: IDeclinedTransactionsDto[]
  ): void {
    state.declinedTransactionsList = declinedTransactionsList;
    state.hasSearchedForDeclinedTransactions = true;
  },

  [DECLINED_TRANSACTIONS_MUTATIONS.SET_DECLINED_TRANSACTIONS_PAGINATION](state, value) {
    state.dataTables.declinedTransactionsList.pagination = value;
  },
  [DECLINED_TRANSACTIONS_MUTATIONS.SET_DECLINED_TRANASCTIONS_FILTERS](state, value) {
    state.dataTables.declinedTransactionsList.declinedTransactionFilters = value;
  },
  [DECLINED_TRANSACTIONS_MUTATIONS.SET_DECLINED_TRANSACTIONS_LIST_TOTAL](state, value) {
    state.totalDeclinedTranasctionCount = value;
  },
  [DECLINED_TRANSACTIONS_MUTATIONS.SET_DECLINE_CODES](state, value) {
    state.declineCodes = value;
  },
};
